/**
 * @generated SignedSource<<2d2408509afa5edbb31555d7592c0d05>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
export type SpaceViewsPersistenceOption = "POPULARITY" | "RECENTLY_MODIFIED" | "RECENTLY_VIEWED" | "TITLE_AZ" | "TREE" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type useSetSpaceViewsSortTransientWriteFragment$data = {
  readonly __typename: "UserPreferences";
  readonly spaceViewsPersistence: SpaceViewsPersistenceOption;
  readonly " $fragmentType": "useSetSpaceViewsSortTransientWriteFragment";
};
export type useSetSpaceViewsSortTransientWriteFragment$key = {
  readonly " $data"?: useSetSpaceViewsSortTransientWriteFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"useSetSpaceViewsSortTransientWriteFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "spaceKey"
    }
  ],
  "kind": "Fragment",
  "name": "useSetSpaceViewsSortTransientWriteFragment",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "spaceKey",
          "variableName": "spaceKey"
        }
      ],
      "kind": "ScalarField",
      "name": "spaceViewsPersistence"
    },
    {
      "kind": "ScalarField",
      "name": "__typename"
    }
  ],
  "type": "UserPreferences"
};

(node as any).hash = "cca4dcc97ad7cd8994207d0b7df73299";

export default node;
